export const ACCOUNT_PROFILE = 'account.profile';

export const lblBdayDrawerCategoryButton = 'lbl_bday_drawer_category_button';
export const lblBdayDrawerHeading = 'lbl_bday_drawer_heading';
export const lblProfileBirthdaySavings = 'lbl_profile_birthday_savings';

const BirthdayModuleLabels = {
  account: {
    profile: {
      [lblBdayDrawerCategoryButton]: 'SHOP ALL',
      [lblBdayDrawerHeading]: 'Birthday Picks for',
      [lblProfileBirthdaySavings]: 'Birthday Savings',
    },
  },
};
export default BirthdayModuleLabels;
